import React from 'react'
import imageData from '../../json/containertwo'
import { Parallax, ParallaxBanner, ParallaxBannerLayer, ParallaxProvider } from 'react-scroll-parallax'
import { useNavigate } from 'react-router-dom'
import './style/twoImage.css'

const SedctionTowImageContainer = () => {
  const navigate = useNavigate();
  let twotext = "";
  let btnstyle = "btn-style2";
  let twotextdec = "";
  if (imageData[0].position === "start") {
    twotext += "text-4xl md:text-6xl  text-white my-5 md:my-10 font-semibold";
    twotextdec +=
      "text-sm text-white my-5 md:my-5 lg:my-10 tracking-wider font-semibold w-96 leading-loose sm:w-none md:w-96";
    btnstyle += " bg-white m-10 px-10 py-3 ";
  }
  return (
    <ParallaxProvider>
      <div>
        {imageData?.map((x, i) => (
          <ParallaxBanner
            style={{ aspectRatio: "2 / 1", height: "100vh" }}
            className="aspect-[2/1] parallax-container"
            key={i}
          >
            <ParallaxBannerLayer
              image={x.img}
              speed={-20}
              style={{ width: "100%", backgroundPosition: "center" }}
            />
            <Parallax className='relative h-full'>
              <div className={`two-text-image `}>
                <p className={`${twotext} pacifico-regular`}>{x.name}</p>
                <p className={`${twotextdec}`}>{x.dec}</p>
                <div className={`btnstyle1`}>
                  <span
                    onClick={() => navigate("/category")}
                    className={`${btnstyle} cursor-pointer `}
                  >
                    {x.btn}
                  </span>
                </div>
              </div>
            </Parallax>
          </ParallaxBanner>
        ))}
      </div>
    </ParallaxProvider>
  )
}

export default SedctionTowImageContainer
